import { getLogger } from '../base/logging/functions';
import { PORTAL_LOG_MODULE } from './constants';
export default getLogger(`features/${PORTAL_LOG_MODULE}`);
